import type { GlobalApplicationsPersonalMenuOrisalesMenuItemDto } from '@ori/global-api-client-react';

import type { MenuItem } from '../schemas/menuItemSchema';

export const mapOrisalesToInternalMenuItems = (
  parentItemPath: string,
  items: GlobalApplicationsPersonalMenuOrisalesMenuItemDto[],
): MenuItem[] =>
  items.map((item, index) => {
    const itemPath = `${parentItemPath}/${index}/`;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- API indeed incorrectly may return value as undefined instead of empty array
    let subItems = item.items ?? [];
    const hasSubitems = !![...subItems].length;

    if (hasSubitems && item.url) {
      subItems = [item, ...subItems];
    }

    return {
      itemPath,
      title: item.name ?? '',
      url: item.url ?? '',
      icon: null,
      subItems: hasSubitems ? mapOrisalesToInternalMenuItems(itemPath, subItems) : [],
      openInNewTab: item.inNewTab,
      isViewable: true,
    };
  });
